import { useEffect, useState } from 'react';
import { useFilters } from 'pos-client/hooks/useFilters.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';
import type {
  AssetTypeSearchRequestModel,
  PagedResponseAssetTypesModel,
} from 'pos-shared/models/assetTypesSchema.ts';

export const useAssetTypesQuery = (
  props: Partial<AssetTypeSearchRequestModel>
) => {
  const {
    name = '',
    resultsPerPage = 10,
    pageNumber = 1,
    sortAscending = false,
  } = props;
  const [assetTypes, setAssetTypes] = useState<PagedResponseAssetTypesModel>();

  const { formFilters, setFormFilters, onPageChange, ...filters } =
    useFilters<AssetTypeSearchRequestModel>({
      name,
      resultsPerPage,
      pageNumber,
      sortAscending,
    });
  const trpcContext = trpc.useContext();

  const { data: searchedAssets, isFetching: isFetchingSearched } =
    trpc.searchAssetTypes.useQuery(formFilters, {
      refetchOnWindowFocus: false,
    });

  const invalidateAssets = async () => {
    await trpcContext.searchAssetTypes.invalidate();
  };

  const invalidateAllAssets = async () => {
    await invalidateAssets();
  };

  useEffect(() => {
    setAssetTypes(searchedAssets);
  }, [searchedAssets]);

  return {
    assetTypes,
    isLoading: isFetchingSearched,
    formFilters,
    setFormFilters,
    invalidateAssets,
    invalidateAllAssets,
    onPageChange,
    ...filters,
  };
};
